import React from 'react';

import { ComboBoxOption } from '../constants';
import SearchResultsListItem from '../SearchResultsListItem/SearchResultsListItem';
import { TestID } from './constants';

export interface Props {
  inputWidth: number;
  maxResultsCount: number;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  selectableOptions: ComboBoxOption[];
  stackSubText?: boolean;
}

const SearchResultsList: React.FC<Props> = ({
  inputWidth = 'auto',
  maxResultsCount,
  onClick,
  selectableOptions,
  stackSubText = false,
}) => (
  <div
    className="absolute bg-white rounded-md border border-gray-300 shadow-md mt-1 p-2 z-10"
    data-testid={TestID}
    style={{ minWidth: inputWidth }}
  >
    <ul>
      {selectableOptions.slice(0, maxResultsCount).map((selectableOption) => (
        <SearchResultsListItem
          key={selectableOption.key}
          onClick={onClick}
          selectableOption={selectableOption}
          stackSubText={stackSubText}
        />
      ))}
    </ul>
  </div>
);

export default SearchResultsList;
